import { it } from "./locales/it";
import { en } from "./locales/en";
import { i18n, options } from "./i18n";

void i18n.init({
  resources: {
    it,
    en,
  },
  ...options,
});

export default i18n;
